import { types } from './profileActions';

const initialState = {
  loading: false,
  error: false,
  item: undefined
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PROFILE:
    case types.REFRESH_PROFILE:
      return {
        ...state,
        loading: true
      };

    case types.GET_PROFILE_SUCCESS:
      return {
        ...state,
        item: action.profile,
        loading: false
      };

    case types.GET_PROFILE_FAILURE:
      return {
        ...state,
        error: action.error || true,
        loading: false
      };

    case types.RESET_PROFILE:
      return initialState;

    default:
      return state;
  }
};
